import React from 'react';
import styled from 'styled-components';

import Badge from '../Badge';
import { Flex } from '../ui';

const BadgeMessage = styled.span`
  margin-left: 4px;
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  height: 24px;
  width: ${({ width }) => width}px;

  svg {
    height: ${({ height }) => height}px;
    width: ${({ width }) => width}px;
  }
`;

const IconBadge = ({
  bgColor = '',
  children,
  className = '',
  fontColor = '',
  icon,
  iconHeight = 12,
  iconWidth = 12,
}) => (
  <Badge bgColor={bgColor} className={className} fontColor={fontColor}>
    <Flex>
      <Icon width={iconWidth} height={iconHeight}>
        {icon}
      </Icon>
      {!!children && <BadgeMessage> {children} </BadgeMessage>}
    </Flex>
  </Badge>
);

export default IconBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/IconBadge.js